import { useState } from "react";
import { toast } from "sonner";
import { logError } from "../utils/logger";

export const useRepresentationAndRequests = (dashboardApi, developerDashboardApi) => {
  const [representationRequests, setRepresentationRequests] = useState([]);
  const [inquiries, setInquiries] = useState([]);
  const [myRequests, setMyRequests] = useState([]);
  const [expandedRequest, setExpandedRequest] = useState(null);
  const [requestResponses, setRequestResponses] = useState([]);

  const fetchRepresentationRequests = async () => {
    try {
      const r = await dashboardApi.getRepresentationRequests();
      if (r.ok) setRepresentationRequests(await r.json());
    } catch (e) {
      logError("useRepresentationAndRequests.fetchRepresentationRequests", e);
    }
  };

  const fetchInquiries = async () => {
    try {
      const r = await dashboardApi.getInquiries();
      if (r.ok) setInquiries(await r.json());
    } catch (e) {
      logError("useRepresentationAndRequests.fetchInquiries", e);
    }
  };

  const fetchMyRequests = async () => {
    try {
      const r = await dashboardApi.getMyRequests();
      if (r.ok) setMyRequests(await r.json());
    } catch (e) {
      logError("useRepresentationAndRequests.fetchMyRequests", e);
    }
  };

  const handleApproveRepresentation = async (propId, reqId) => {
    try {
      const r = await developerDashboardApi.approveRepresentation(
        propId,
        reqId,
      );
      if (!r.ok) throw new Error();
      toast.success("Broker aprobado");
      fetchRepresentationRequests();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleRejectRepresentation = async (propId, reqId) => {
    if (!window.confirm("¿Rechazar esta solicitud?")) return;
    try {
      const r = await developerDashboardApi.rejectRepresentation(propId, reqId);
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        throw new Error(e.detail || "Error al rechazar");
      }
      toast.success("Solicitud rechazada");
      fetchRepresentationRequests();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const loadResponses = async (reqId) => {
    try {
      const r = await dashboardApi.getRequestResponses(reqId);
      if (r.ok) {
        setRequestResponses(await r.json());
        setExpandedRequest(reqId);
      }
    } catch (e) {
      toast.error("Error al cargar respuestas");
    }
  };

  const updateRequestStatus = async (reqId, status) => {
    try {
      const r = await dashboardApi.updateRequestStatus(reqId, status);
      if (r.ok) {
        toast.success("Estado actualizado");
        fetchMyRequests();
      }
    } catch (e) {
      toast.error("Error");
    }
  };

  const archiveInquiry = async (id) => {
    try {
      const r = await developerDashboardApi.archiveInquiry(id);
      if (r.ok) {
        toast.success("Consulta archivada");
        fetchInquiries();
      }
    } catch (e) {
      toast.error("Error");
    }
  };

  return {
    representationRequests,
    inquiries,
    myRequests,
    expandedRequest,
    setExpandedRequest,
    requestResponses,
    fetchRepresentationRequests,
    fetchInquiries,
    fetchMyRequests,
    handleApproveRepresentation,
    handleRejectRepresentation,
    loadResponses,
    updateRequestStatus,
    archiveInquiry,
  };
};
